import AccountMarketingMaterialWeddingTableTentTemplate from './AccountMarketingMaterialShutterbugTableTentTemplate';

export default AccountMarketingMaterialWeddingTableTentTemplate;
